import { Dispatch, SetStateAction } from 'react';
import { ace_index } from '@axo/shared/data-access/types';
import { FilterSelect } from '../FilterSelect';
import { setPageNumber } from '../SearchResults';

interface Props {
  query: ace_index.FindInput;
  setQuery: Dispatch<SetStateAction<ace_index.FindInput>>;
  editable?: boolean;
}

export function HasCreditWarning({ query, setQuery, editable = false }: Props) {
  const state = getState(query);
  const value = options.find((option) => option.value === state);

  return (
    <FilterSelect
      items={options}
      onSelect={(option) => setQuery(setState(option.value))}
      stringify={(option) => option.label}
      value={value}
      label="Has credit warning"
      description="Filter whether the applicant has a credit warning"
      disabled={!editable}
    />
  );
}

// Yes / No only: with neither picked the field is left out of the request.
const options = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

function setState(value: Value): SetStateAction<ace_index.FindInput> {
  return (query) => ({
    ...setPageNumber(1)(query),
    PersonCreditWarning: value,
  });
}

function getState(query: ace_index.FindInput) {
  return query.PersonCreditWarning;
}

type Value = ace_index.FindInput['PersonCreditWarning'];
